<template>
  <div class="modal fade" id="assignFile" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold" id="exampleModalLongTitle">Assign Turn Over Notes</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for="searchCrewTo" class="font-weight-bold">Assign To (Crew):</label>
            <input type="text" class="form-control" id="searchCrewTo" placeholder="Search Crew Here . .">
          </div>
        </div>
        <div class="modal-footer">
          <base-secondary-btn v-on:click.native="closeModal()"> Close </base-secondary-btn>
          <base-primary-btn> Save </base-primary-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AssignFileToCrew",
  /** mixins **/
  mixins: [],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {};
  },

  /** methods**/
  methods: {
    closeModal() {
      $("#assignFile").modal('hide');
    }
  },

  /**  computed  **/
  computed: {},

  /** mounted **/
  mounted() {
  },

  /** created **/
  created() {
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
  },
}
</script>

<style scoped lang="scss">

</style>